import { BaseElement } from 'base';
import { bus } from 'bus';

class SelectionField extends BaseElement {
  #handlers = new Set();

  onConnect() {
    this.input = this.q('input');
    this.topic = this.dataset.topic;
    this.listen(this.input, 'change', this.#emit);

    if (this.topic && (this.input.type !== 'radio' || this.input.checked)) {
      this.#emit();
    }
  }

  get checked() {
    return this.input.checked;
  }

  get value() {
    return this.input.value;
  }

  onChange(handler) {
    this.#handlers.add(handler);
    return () => this.#handlers.delete(handler);
  }

  onDisconnect() {
    this.#handlers.clear();
  }

  #emit() {
    const detail = {
      id: this.input.id,
      value: this.input.value,
      checked: this.input.checked
    };

    if (this.topic) bus.publish(this.topic, detail);

    for (const handler of [...this.#handlers]) {
      try {
        handler(detail);
      } catch (error) {
        console.error('[selection-field] change handler failed:', error);
      }
    }
  }
}

if (!customElements.get('selection-field'))
  customElements.define('selection-field', SelectionField);
